import {useChekinSDK} from 'context/ChekinSDK';
import {getLogo} from 'utils/getLogo';
import {useFetchHousing} from 'hooks';
import {AUTH_INIT_MODELS, GUESTAPP_NAVIGATION_MODE} from '@chekin/core';
import {useCustomTheme} from 'context/customTheme';

function usePropertyLinkInfo() {
  const {objectId: housingId, modelName} = useChekinSDK();
  const {data: template, hasTemplate, isLoadedTemplate} = useCustomTheme();

  const {data: housing, isSuccess: isSuccessHousing} = useFetchHousing(housingId, {
    refetchOnWindowFocus: false,
    enabled: modelName === AUTH_INIT_MODELS.housing,
  });

  const hasTitle = template?.navigation_title_type !== GUESTAPP_NAVIGATION_MODE.logo;
  const title = hasTitle ? housing?.display_name ?? housing?.name : undefined;
  const isHousingLoaded = Boolean(isSuccessHousing && housing?.id);
  const isLoaded = hasTemplate ? isHousingLoaded && isLoadedTemplate : isHousingLoaded;
  const onlyLogo = template?.navigation_title_type === GUESTAPP_NAVIGATION_MODE.logo;

  const logo = getLogo({
    housingLogo: housing?.picture?.src,
    template,
    isSuccess: isLoaded,
  });

  return {logo, title, isLoaded, onlyLogo};
}

export default usePropertyLinkInfo;
